export default __webpack_public_path__ + "static/youngones-ffb120dac12ef54d39cd868618e60980c8901ffad5da92e8568a1d8434a863ca.png";